//bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import BaoDialogViewModel from "./bao-dialog";
import dialogTemplate from "./bao-search-dialog.html";
import tabPage from "./tab-page";
import "./../bindings/bao-pager";
import "./../bindings/sorting";
import "./../bindings/foreach-selection";
import "./../bindings/fade-visible";
import "./../bindings/slide-visible";
import "./../components/base-config";
function _defaults() {
    this.NewVisible = ko.observable(false);
    this.ApplyItemCallback = function (viewModel) { };
    this.CustomFilter = ko.observable();
    this.Items = ko.observableArray([]);
    this.MultiSelect = false;
    this.SearchType = "";
    this.ResetAfterSearch = ko.observable(true);
}
function _isSelected(model, root) {
    var isSelected = false;
    if (root.SelectionMode() == "multi") {
        $.each(root.Selection(), function (index, i) {
            if (ko.unwrap(i.PrimaryKeyValue) == ko.unwrap(model.PrimaryKeyValue)) {
                isSelected = true;
                return false;
            }
        });
    }
    else {
        if (ko.unwrap(root.Selection().PrimaryKeyValue) == ko.unwrap(model.PrimaryKeyValue)) {
            isSelected = true;
        }
    }
    return isSelected;
}
function _checkSelection(item, items) {
    if (item.selected() == false) {
        $.each(items(), function (index, i) {
            if (ko.unwrap(i.PrimaryKeyValue) == ko.unwrap(item.PrimaryKeyValue)) {
                i.selected(false);
            }
            if (ko.unwrap(i.__Children) != null && i.__Children().length > 0) {
                _checkSelection(item, i.__Children);
            }
        });
    }
}
function _buildModels(models, level, root, parent) {
    if (models != null) {
        ko.utils.arrayForEach(models, function (m: any) {
            m.__Children = ko.observableArray();
            m.__Level = level;
            m.__Root = root;
            m.__Opened = ko.observable(false);
            m.__Loaded = ko.observable(false);
            m.__Parent = parent;
            if (m.selected == undefined) {
                m.selected = ko.observable(false);
                m.selected.subscribe(function () {
                    _checkSelection(m, root.Models);
                });
            }
            m.selected(_isSelected(m, root));
            m.__ExpandedIcon = ko.computed(function () {
                if (m.__Opened()) {
                    return "fa-minus-square";
                }
                else {
                    return "fa-plus-square";
                }
            });
        });
    }
    return models;
}
function GetCustomFilter(initValues, customFilterTemp) {
    var iObject = 0;
    var customFilterHashObject = [];
    var keys = {};
    if (initValues != null && ko.unwrap(initValues.CustomFilter) != null) {
        $.each(ko.unwrap(initValues.CustomFilter), function (key, value) {
            var hashObject :any = {};
            hashObject.Key = key;
            hashObject.Value = value;
            customFilterHashObject[iObject] = hashObject;
            iObject++;
            keys[key] = key;
        });
    }
    if (ko.unwrap(customFilterTemp) != null) {
        $.each(ko.unwrap(customFilterTemp), function (key, value) {
            if (keys[key] == null) {
                var hashObject : any= {};
                hashObject.Key = key;
                hashObject.Value = value;
                customFilterHashObject[iObject] = hashObject;
                iObject++;
            }
        });
    }
    return ko.map.toJS(customFilterHashObject);
}
function NewItemViewModel(callBack, valueAccessor) {
    var self = this;
    var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    var _viewModel = null;
    self.Save = function () {
        _viewModel = dialog.ViewModel().ViewModel();
        if (_viewModel.CompleteCheck() == true) {
            _viewModel.Save().then(function () {
                dialog.Close();
                callBack(_viewModel, true);
            });
        }
    };
    dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgSave"),
            Click: self.Save,
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                dialog.Close();
                callBack(null, false);
            },
            Enabled: ko.observable(true)
        }]);
    var _init = function (valueAccessor) {
        Bao.post("Search/GetNewModel", JSON.stringify(ko.toJS({
            searchKey: ko.unwrap(valueAccessor).SearchType
        })), function (model) {
            if (!Bao.Utils.String.IsNullOrWhitespace(model.NewOpenUrl)) {
                dialog.Open();
                dialog.IsLoading(true);
                Bao.get(model.NewOpenUrl, function (result) {
                    dialog.ViewModel(new tabPage());
                    dialog.Template(result);
                    dialog.IsLoading(false);
                });
            }
        });
    };
    _init(valueAccessor);
}
function BaoSearchDialogViewModel(dialog, initValues) {
    var self = this;
    self.Bao = Bao;
    if (initValues)
        $.extend(self, ko.createBindingConfig(initValues, new _defaults()));
    if (!ko.isObservable(self.CustomFilter)) {
        self.CustomFilter = ko.observable(self.CustomFilter);
    }
    self.New = function () {
        dialog.Hide();
        var newItemVM = new NewItemViewModel(function (newItem, saved) {
            if (saved) {
                self.SelectedItem(newItem);
                self.ApplyItem();
            }
            else {
                dialog.Show();
            }
        }, initValues);
    };
    self.SelectionMode = ko.observable("single");
    self.Selection = ko.observableArray();
    self.Selection.subscribe(function () {
        if (self.Selection() != null && self.Selection().length > 0) {
            self.SelectedItem(self.Selection()[0]);
        }
        else {
            self.SelectedItem(null);
        }
    });
    self.GetChildren = function (item) {
        var def = $.Deferred();
        if (item != null && item.__Loaded() != true) {
            Bao.post("Search/GetChildren", JSON.stringify({
                parentId: ko.unwrap(item.PrimaryKeyValue),
                searchKey: self.SearchKey()
            }), function (result) {
                item.__Children(_buildModels(result, item.__Level + 1, self, item));
                item.__Opened(true);
                item.__Loaded(true);
                def.resolve();
            });
        }
        else if (item != null) {
            item.__Opened(!item.__Opened());
            if (item.__Opened() == false) {
                self.CloseChildren(item.__Children);
            }
            def.resolve();
        }
        return def.promise();
    };
    self.CloseChildren = function (children) {
        if (children != null && children().length > 0) {
            ko.utils.arrayForEach(children(), function (c: any) {
                c.__Opened(false);
                self.CloseChildren(c.__Children);
            });
        }
    };
    self.MultiSelect = ko.observable(false);
    self.MultiSelect.subscribe(function () {
        if (self.MultiSelect() == true) {
            self.SelectionMode("multi");
        }
        else {
            self.SelectionMode("single");
        }
    });
    self.ToggleMultiSelect = function () {
        if (self.MultiSelect() != null) {
            self.MultiSelect(!self.MultiSelect());
        }
    };
    self.ShowBadges = ko.observable(false);
    self.ResetAfterSearch = ko.observable(true);
    self.BadgeText = ko.observable("Value");
    self.removeItem = function (item, e) {
        const model = self.Models().find(m => ko.unwrap(m.PrimaryKeyValue) === ko.unwrap(item.PrimaryKeyValue));
        const itemToRemove = this.Items().find(i => ko.unwrap(i.PrimaryKeyValue) === ko.unwrap(item.PrimaryKeyValue));
        if (itemToRemove != null) {
            if (model != null) {
                model.selected(false);
            }
            self.Selection.remove(itemToRemove);
        } else {
            item.selected(false); 
            self.Selection.remove(item);
        }
    };
    self.PageModeContinousId = "00000000-0000-0000-0000-000000000001";
    self.PageModePagingId = "00000000-0000-0000-0000-000000000002";
    self.SearchFocus = function () { };
    self.SearchExecuted = ko.observable(false);
    self.SortColumnList = ko.observableArray([]);
    self.LayoutKey = ko.observable();
    self.SortColumnKey = ko.observable();
    self.Sorting = ko.observableArray([]);
    self.Sorting.subscribe(function () {
        self.PageIndex(0);
        self.Search();
    });
    self.SearchKey = ko.observable();
    self.SearchText = ko.observable("");
    self.SearchTextTemp = ko.observable("");
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        if (self.PagingMode() == self.PageModePagingId) {
            if (self.SearchExecuted() == false) {
                self.Search(false);
            }
        }
    });
    self.PageSize = ko.observable(25);
    self.PageSize.subscribe(function () {
        if (self.PagingMode() == self.PageModePagingId) {
            if (self.SearchExecuted() == false) {
                self.Search(true);
            }
        }
    });
    self.PagingMode = ko.observable(self.PageModePagingId);
    self.ExpandedSearchTemplateName = ko.observable();
    self.ExpandedSearch = null;
    self.ResetCustomFilter = function () {
        if (self.ExpandedSearch != null && self.ExpandedSearch.Reset != null && typeof self.ExpandedSearch.Reset == "function") {
            self.ExpandedSearch.Reset();
        }
        self.RefreshExpandedSearch();
    };
    self.RefreshExpandedSearch = function () {
        var def = $.Deferred();
        self.CustomFilter(null);
        self.ExpandedSearch = null;
        self.ExpandedSearchTemplateName(null);
        self.ExpandedSearchVisible(false);
        Bao.post("Search/GetExpandedSearchJavaScript", JSON.stringify({
            searchKey: self.SearchKey()
        }), function (result) {
            if (result != "") {
                window.baorequire([result], function (expandedViewModel) {
                    self.ExpandedSearch = new expandedViewModel(self, initValues);
                    self.ExpandedSearch.init().then(function () {
                        def.resolve();
                    });
                }, def.resolve);
            }
            else {
                def.resolve();
            }
        }).fail(def.resolve);
        return def.promise();
    };
    self.ExpandedSearchVisible = ko.observable(false);
    self.ToggleExpandedSearch = function () {
        self.ExpandedSearchVisible(!self.ExpandedSearchVisible());
    };
    self.TemplateContainer = ko.observable();
    self.SelectedItem = ko.observable();
    self.SelectedItem.subscribe(function () {
        if (self.SelectedItem() != null) {
            dialog.Buttons()[0].Enabled(true);
        }
        else {
            dialog.Buttons()[0].Enabled(false);
        }
    });
    self.TotalRows = ko.observable(0);
    self.SortColumnKey.subscribe(function (newValue) {
        if (newValue != null) {
            self.Sorting([{
                    Column: newValue,
                    Direction: "Ascending"
                }]);
        }
    });
    self.CustomFilter = ko.observable();
    self.CustomFilterTemp = ko.observable();
    self.Models = ko.observableArray([]);
    self.UniqueLayoutKey = ko.observable();
    self.ColumnLayoutId = ko.observable("");
    self.SearchSystemSettings = ko.observableArray();
    
    var loadedLayout = "loading";
    self.LoadLayout = function () {
        var def = $.Deferred();
        if (loadedLayout != self.LayoutKey()) {
            Bao.post("Search/GetSearchSystemSettings", (result) => {
                self.SearchSystemSettings(result);
                Bao.post("Search/GetLayout", JSON.stringify({
                    searchKey: self.SearchKey(),
                    layoutKey: "",
                    type: "Dialog"
                }), function (templateResult) {
                    self.PageSize(templateResult.PageSize);
                    self.PagingMode(templateResult.Mode);
                    loadedLayout = templateResult.LayoutKey;
                    self.LayoutKey(templateResult.LayoutKey);
                    Bao.Templates[self.SearchKey() + self.LayoutKey()] = templateResult.Template;
                    self.UniqueLayoutKey(self.SearchKey() + self.LayoutKey());
                    self.ColumnLayoutId("search_" + self.UniqueLayoutKey());
                    def.resolve();
                });
            });
        }
        else {
            def.resolve();
        }
        return def;
    };
    self.PerformSearch = function (resetIndex) {
        self.SearchTextTemp(self.SearchText());
        self.CustomFilterTemp(self.CustomFilter());
        self.Search(true);
    };
    self.Search = function (resetIndex) {
        dialog.IsLoading(true);
        if (resetIndex == null) {
            resetIndex = true;
        }
        if (resetIndex) {
            self.PageIndex(0);
        }
        self.SearchExecuted(true);
        var customFilter = self.GetCustomFilter();
        $.when(self.LoadLayout()).then(function () {
            var s = self.SearchTextTemp();
            Bao.post("Search/SearchItems", JSON.stringify({
                searchKey: self.SearchKey(),
                searchString: s,
                customFilter: customFilter,
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SearchExecuted(false);
                if (searchResult != null) {
                    if (searchResult.Models != null) {
                        self.TotalRows(searchResult.TotalRows);
                        self.Models(_buildModels(searchResult.Models, 0, self, null));
                        dialog.SetPosition();
                    }
                    else {
                        const dialogModel = new BaoDialogViewModel(Bao.Session.ApplicationName());
                        dialogModel.Width(500);

                        dialogModel.Template(searchResult.Message);
                        dialogModel.Buttons([{
                            Title: "Ok", Click: function () {
                                dialogModel.Close();
                            }, Enabled: ko.observable(true)
                        }]);
                        dialogModel.Open();

                    }
                }
                dialog.IsLoading(false);
                self.SearchFocus();
            });
        });
    };
    self.Open = function (index, item, event) {
        if (item != null) {
            setTimeout(function () {
                self.SelectedItem(item);
                self.Selection([item]);
                self.ApplyItem();
            }, 0);
        }
        if (event != null) {
            Bao.Utils.stopPropagation(event);
        }
    };
    self.ApplyItem = function () {
        self.ApplyItemCallback(self);
        dialog.Close();
    };
    self.GetCustomFilter = function () {
        return GetCustomFilter(initValues, self.CustomFilterTemp);
    };
}
function DialogFactory() {
    var self = this;
    var _initialized = false;
    BaoDialogViewModel.call(this, Bao.Session.ApplicationName);
    self.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                self.ViewModel().ApplyItem();
            },
            Enabled: ko.observable(false)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: self.Close,
            Enabled: ko.observable(true)
        }]);
    self.InitSearcher = function (initValues) {
        self.ViewModel(new BaoSearchDialogViewModel(self, initValues));
        self.ViewModel().MultiSelect(ko.unwrap(initValues.MultiSelect));
        self.ViewModel().SearchKey(ko.toJS(initValues.SearchType));
        self.ViewModel().ShowBadges(ko.unwrap(initValues.MultiSelect));
        if (ko.unwrap(initValues.ShowBadges) === false) {
            self.ViewModel().ShowBadges(false);
        }
        self.ViewModel().ResetAfterSearch(ko.unwrap(initValues.ResetAfterSearch));
        self.ViewModel().BadgeText(ko.unwrap(initValues.ObjectValue));
        self.IsLoading(true);
        self.Open();
        self.ViewModel().RefreshExpandedSearch();
        if (self.ViewModel().SearchFocus != undefined) {
            self.Template(dialogTemplate);
            self.IsLoading(false);
            self.ViewModel().SearchFocus();
            if (ko.toJS(initValues.AutoSearch) == true) {
                self.ViewModel().Search();
            }
        }
    };
}
export default DialogFactory;